import * as React from 'react';
import TrialBadge from './TrialBadge';

export const trialBadge = () => <TrialBadge />;

export default {
    title: 'Components/Badges/TrialBadge',
    component: TrialBadge,
};
